import http from "./http";

export const getPackages = async () => {
  const { data } = await http.get("superadmin/packages");
  return data;
};

export const createPackage = async (payload) => {
  const { data } = await http.post(
    "superadmin/packages",
    payload
  );
  return data;
};

export const updatePackage = async (payload) => {
  const { data } = await http.put(
    "superadmin/packages",
    payload
  );
  return data;
};

export const deletePackage = async (id) => {
  const { data } = await http.delete(
    `superadmin/packages?id=${id}`
  );
  return data;
};